import dates from "../services/dates";
import {MODELS} from "../services/models";
import utils from "../services/utils";
import {ENUMS} from "../services/enums";
import {timeFrames} from "../services/staticData";
import router from "../router";

const state = () => ({
  columns: {
    leads: {
      line_1: {
        class: MODELS.Property.class_name,
        label: 'Street Address',
        field: 'property_street_address',
        sortable: true,
        visible: true,
        sticky: true,
        display(row, vue) {
          return `<span class="text-clickable">${row.property_street_address}</span>`;
        },
        onClick(row, vue) {
          router.replace({query: {lead: row.id}});
        },
      },
      city: {
        class: MODELS.Property.class_name,
        label: 'City',
        field: 'property_city',
        sortable: true,
        visible: true,
      },
      state: {
        class: MODELS.Property.class_name,
        label: 'State',
        field: 'property_state',
        sortable: true,
        visible: true,
      },
      postcode: {
        class: MODELS.Property.class_name,
        label: 'Postcode',
        field: 'property_postcode',
        isNumeric: true,
        sortable: true,
        visible: true,
      },
      nextContactAt: {
        class: MODELS.Record.class_name,
        label: 'Next Contact At',
        field: 'next_contact_at',
        sortable: true,
        visible: true,
        display(row) {
          return dates.formatAsDate(row.next_contact_at)
        }
      },
      contactName: {
        class: MODELS.Contact.class_name,
        label: 'Primary Contact - Name',
        field: 'primary_contact_name',
        sortable: true,
        visible: true,
      },
      contactPhone: {
        class: MODELS.Contact.class_name,
        label: 'Primary Contact - Phone',
        field: 'primary_contact_phone',
        isNumeric: true,
        sortable: true,
        visible: true,
      },
      contactEmail: {
        class: MODELS.Contact.class_name,
        label: 'Primary Contact - Email',
        field: 'primary_contact_email_address',
        sortable: true,
        visible: true,
      },
      contactAddress: {
        class: MODELS.Contact.class_name,
        label: 'Primary Contact - Address',
        field: 'primary_contact_street_address',
        visible: true,
      },
      campaign: {
        class: MODELS.Record.class_name,
        label: 'Campaign',
        field: 'campaign',
        visible: true,
      },
      motivation: {
        class: MODELS.Record.class_name,
        label: 'Motivation',
        field: 'motivation',
        visible: true,
        display(row) {
          return utils.newGetEnumLabel(row.motivation, ENUMS.MotivationEnum)
        }
      },
      exitStrategy: {
        class: MODELS.Record.class_name,
        label: 'Exit Strategy',
        field: 'exit_strategy',
        visible: true,
        display(row) {
          return utils.newGetEnumLabel(row.exit_strategy, ENUMS.ExitStrategyEnum)
        }
      },
      temperature: {
        class: MODELS.Record.class_name,
        label: 'Temperature',
        field: 'temperature',
        visible: true,
        display(row) {
          return utils.newGetEnumLabel(row.temperature, ENUMS.TemperatureEnum)
        }
      },
      bedrooms: {
        class: MODELS.Property.class_name,
        label: 'Bedrooms',
        field: 'bedrooms',
        isNumeric: true,
        sortable: true,
        visible: true,
      },
      bathrooms: {
        class: MODELS.Property.class_name,
        label: 'Bathrooms',
        field: 'bathrooms',
        isNumeric: true,
        sortable: true,
        visible: true,
      },
      houseSize: {
        class: MODELS.Record.class_name,
        label: 'Sq Ft',
        field: 'sq_ft',
        isNumeric: true,
        sortable: true,
        visible: true,
      },
      lotSize: {
        class: MODELS.Record.class_name,
        label: 'Lot Size',
        field: 'lot_size',
        isNumeric: true,
        sortable: true,
        visible: true,
      },
      yearBuilt: {
        class: MODELS.Record.class_name,
        label: 'Year Built',
        field: 'year_built',
        isNumeric: true,
        sortable: true,
        visible: true,
      },
      arv: {
        class: MODELS.Record.class_name,
        label: 'ARV',
        field: 'after_repair_value',
        isNumeric: true,
        sortable: true,
        visible: true,
        display(row) {
          return (row.after_repair_value) ? utils.formatCurrency(row.after_repair_value) : '--'
        }
      },
      mao: {
        class: MODELS.Record.class_name,
        label: 'MAO',
        field: 'maximum_allowable_offer',
        isNumeric: true,
        sortable: true,
        visible: true,
        display(row) {
          return (row.maximum_allowable_offer) ? utils.formatCurrency(row.maximum_allowable_offer) : '--'
        }
      },
      latestOfferAmount: {
        class: MODELS.Record.class_name,
        label: 'Latest Offer Amount',
        field: 'latest_offer_amount',
        isNumeric: true,
        // sortable: true,
        visible: true,
        display(row) {
          return (row.latest_offer_amount) ? utils.formatCurrency(row.latest_offer_amount) : '--'
        }
      },
      projectedProfit: {
        class: MODELS.Record.class_name,
        label: 'Projected Profit',
        field: 'projected_profit',
        isNumeric: true,
        sortable: true,
        visible: true,
        display(row) {
          return (row.projected_profit) ? utils.formatCurrency(row.projected_profit) : '--'
        }
      },
      saleAmount: {
        class: MODELS.Record.class_name,
        label: 'Sale Amount',
        field: 'sale_amount',
        isNumeric: true,
        sortable: true,
        visible: true,
        display(row) {
          return (row.sale_amount) ? utils.formatCurrency(row.sale_amount) : '--'
        }
      },
      actualProfit: {
        class: MODELS.Record.class_name,
        label: 'Actual Profit',
        field: 'actual_profit',
        isNumeric: true,
        sortable: true,
        visible: true,
        display(row) {
          return (row.actual_profit) ? utils.formatCurrency(row.actual_profit) : '--'
        }
      },
    },
    preset: {
      line_1: {
        class: MODELS.Property.class_name,
        label: 'Street Address',
        field: 'property_street_address',
        visible: true,
      },
      city: {
        class: MODELS.Property.class_name,
        label: 'City',
        field: 'property_city',
        visible: true,
      },
      state: {
        class: MODELS.Property.class_name,
        label: 'State',
        field: 'property_state',
        visible: true,
      },
      postcode: {
        class: MODELS.Property.class_name,
        label: 'Postcode',
        field: 'property_postcode',
        visible: true,
      },
      nextContactAt: {
        class: MODELS.Record.class_name,
        label: 'Next Contact At',
        field: 'next_contact_at',
        visible: true,
      },
      contactName: {
        class: MODELS.Contact.class_name,
        label: 'Primary Contact - Name',
        field: 'primary_contact_name',
        visible: true,
      },
      contactPhone: {
        class: MODELS.Contact.class_name,
        label: 'Primary Contact - Phone',
        field: 'primary_contact_phone',
        visible: true,
      },
      contactEmail: {
        class: MODELS.Contact.class_name,
        label: 'Primary Contact - Email',
        field: 'primary_contact_email_address',
        visible: true,
      },
      contactAddress: {
        class: MODELS.Contact.class_name,
        label: 'Primary Contact - Address',
        field: 'primary_contact_street_address',
        visible: true,
      },
      campaign: {
        class: MODELS.Record.class_name,
        label: 'Campaign',
        field: 'campaign',
        visible: true,
      },
      motivation: {
        class: MODELS.Record.class_name,
        label: 'Motivation',
        field: 'motivation',
        visible: true,
      },
      exitStrategy: {
        class: MODELS.Record.class_name,
        label: 'Exit Strategy',
        field: 'exit_strategy',
        visible: true,
      },
      temperature: {
        class: MODELS.Record.class_name,
        label: 'Temperature',
        field: 'temperature',
        visible: true,
      },
      bedrooms: {
        class: MODELS.Property.class_name,
        label: 'Bedrooms',
        field: 'bedrooms',
        visible: true,
      },
      bathrooms: {
        class: MODELS.Property.class_name,
        label: 'Bathrooms',
        field: 'bathrooms',
        visible: true,
      },
      houseSize: {
        class: MODELS.Record.class_name,
        label: 'Sq Ft',
        field: 'sq_ft',
        visible: true,
      },
      lotSize: {
        class: MODELS.Record.class_name,
        label: 'Lot Size',
        field: 'lot_size',
        visible: true,
      },
      yearBuilt: {
        class: MODELS.Record.class_name,
        label: 'Year Built',
        field: 'year_built',
        visible: true,
      },
      arv: {
        class: MODELS.Record.class_name,
        label: 'ARV',
        field: 'after_repair_value',
        visible: true,
      },
      mao: {
        class: MODELS.Record.class_name,
        label: 'MAO',
        field: 'maximum_allowable_offer',
        visible: true,
      },
      latestOfferAmount: {
        class: MODELS.Record.class_name,
        label: 'Latest Offer Amount',
        field: 'latest_offer_amount',
        visible: true,
      },
      projectedProfit: {
        class: MODELS.Record.class_name,
        label: 'Projected Profit',
        field: 'projected_profit',
        visible: true,
      },
      saleAmount: {
        class: MODELS.Record.class_name,
        label: 'Sale Amount',
        field: 'sale_amount',
        visible: true,
      },
      actualProfit: {
        class: MODELS.Record.class_name,
        label: 'Actual Profit',
        field: 'actual_profit',
        visible: true,
      },
    },
  },
  filters: {
    leads: {
      users: [],
      recordStates: [],
      statuses: [],
      sequences: null,
      sources: null,
      sourceId: null,
      timeFrames: null,
      timeFrameValues: [],
      campaigns: null,
      exitStrategies: null,
      temperatures: null,
      dealProbabilityScore: null,
      hasTasks: null,
      taskTag: null,
      postcode: null,
      beds: null,
      baths: null,
      sqft: null,
      lotSize: null,
      yearBuilt: null,
    },
    preset: {
      users: [],
      recordStates: [],
      statuses: [],
      sequences: null,
      sources: null,
      sourceId: null,
      timeFrames: null,
      timeFrameValues: [],
      campaigns: null,
      exitStrategies: null,
      temperatures: null,
      dealProbabilityScore: null,
      hasTasks: null,
      taskTag: null,
      postcode: null,
      beds: null,
      baths: null,
      sqft: null,
      lotSize: null,
      yearBuilt: null,
    },
  },
});

const getters = {
  columns: (state) => (columnObject) => {
    return state.columns[columnObject]
  },
  filters: (state) => (filterObject) => {
    return state.filters[filterObject]
  },
  filterCount(state, getters) {
    let count = 0
    for (let filterKey in getters.filters('leads')) {
      const filterValue = getters.filters('leads')[filterKey]

      if (filterKey !== 'page' && filterKey !== 'sourceId') {
        if (filterValue !== null
          && (typeof filterValue === "object" || typeof filterValue === "string")
          && filterValue.length !== 0)
        {
          count += 1
        }

        if (typeof filterValue === "boolean") {
          count += 1
        }

        if (typeof filterValue === "number") {
          count += 1
        }
      }
    }

    return count
  }
};

const mutations = {
  addCustomFieldsToColumns(state, [columnObject, properties]) {
    const objects= Object.fromEntries(properties.map(item => [item.key, item.value]));
    state.columns[columnObject] = Object.assign({}, state.columns[columnObject], objects)
  },
  setOneColumn(state, [columnObject, columnKey, value]) {
    state.columns[columnObject][columnKey].visible = value
  },
  setOneFilter(state, [filterObject, filter, value, customValue = null]) {
    state.filters[filterObject][filter] = value

    if (filter === 'timeFrames') {
      const timeFrameValue = timeFrames.find(t => t.value === state.filters[filterObject][filter])
      if (value === 'custom' && customValue && !timeFrameValue) {
        state.filters[filterObject].timeFrameValues = {
          start: customValue.start,
          end: customValue.end
        }
      }

      if (timeFrameValue) {
        state.filters[filterObject].timeFrameValues = {
          start: timeFrameValue.start,
          end: timeFrameValue.end,
        }
      }
    }
  },
  resetColumns(state, columnObject) {
    for (let columnsKey in state.columns[columnObject]) {
      state.columns[columnObject][columnsKey].visible = true
    }
  },
  resetFilters(state, filterObject) {
    // Make sure to update state default
    state.filters[filterObject] = {
      users: [],
      recordStates: [],
      statuses: [],
      sequences: null,
      sources: null,
      sourceId: null,
      timeFrames: null,
      timeFrameValues: [],
      campaigns: null,
      exitStrategies: null,
      temperatures: null,
      dealProbabilityScore: null,
      hasTasks: null,
      taskTag: null,
      postcode: null,
      beds: null,
      baths: null,
      sqft: null,
      lotSize: null,
      yearBuilt: null,
    }
  }
};

const actions = {
  setup({commit, dispatch, state, getters, rootGetters}, columnObject) {
    dispatch('loadCustomFieldsColumns', columnObject)

    const defaultPreset = rootGetters.leadsTableConfigurations.find(preset => preset.id === rootGetters.authUser.default_leads_table_preset_id)
    if (! defaultPreset) {
      commit("resetColumns", "leads")
      commit("resetFilters", "leads")
      return
    }

    for (const [columnKey, columnValue] of Object.entries(getters.columns("leads"))) {
      const columnPreset = defaultPreset.columns.find(preset => preset.field === columnValue.field)
      if (columnPreset) {
        commit("setOneColumn", ["leads", columnKey, columnPreset.visible])
      }
    }

    for (const [filterKey, filterValue] of Object.entries(getters.filters("leads"))) {
      const filterPresetValue = defaultPreset.filters[filterKey]
      if (filterPresetValue) {
        commit("setOneFilter", ["leads", filterKey, filterPresetValue])
      }
    }
  },
  loadCustomFieldsColumns({commit, state, rootGetters}, columnObject) {
    let customFieldColumns = rootGetters.recordCustomFields.map(customField => {
      if (columnObject === 'preset') {
        return {
          key: utils.camelCase(customField.label),
          value: {
            class: customField.class_name,
            label: customField.label,
            field: customField.import_label,
            visible: true,
          }
        }
      }

      return {
        key: utils.camelCase(customField.label),
        value: {
          class: customField.class_name,
          label: customField.label,
          field: customField.import_label,
          visible: true,
          display(row) {
            if (row['custom_fields'].length === 0) return '--'

            const field = row['custom_fields'][customField.import_label]
            if (!field) return '--';

            if (!field.value) return '--'

            if (customField.type === ENUMS.CustomFieldTypeEnum.Date.value) return dates.formatAsDate(field.value)

            if (customField.type === ENUMS.CustomFieldTypeEnum.Currency.value) return utils.formatCurrency(field.value)

            if (customField.type === ENUMS.CustomFieldTypeEnum.Time.value) return dates.formatAsTime(field.value)

            if (customField.type === ENUMS.CustomFieldTypeEnum.TextArea.value) return utils.truncateString(field.value, 140)

            return field.value
          }
        }
      }
    })

    // this is here, so it will be always the last column
    if (columnObject === 'preset') {
      customFieldColumns.push({
        key: 'createdAt',
        value: {
          class: MODELS.Record.class_name,
          label: 'Created At',
          field: 'created_at',
          visible: true,
        },
      })
    } else {
      customFieldColumns.push({
        key: 'createdAt',
        value: {
          class: MODELS.Record.class_name,
          label: 'Created At',
          field: 'created_at',
          sortable: true,
          visible: true,
          display(row) {
            return dates.formatAsDate(row.created_at)
          }
        },
      })
    }

    commit("addCustomFieldsToColumns", [columnObject, customFieldColumns])
  },
};

const LeadsStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default LeadsStore;
